<template>
    <div>
       <div>
            <ul class="nav nav-pills nav-fill" role="tablist">
                <li class="nav-item">
                    <a 
                        href="#data" 
                        class="nav-link active"
                        id="data-tab"
                        role="tab"
                        aria-controls="data"
                        aria-selected="true"
                        data-toggle="tab"
                    >
                        <i class="fa fa-dropbox"></i>
                        Quotation Packages
                    </a>
                </li>
            </ul>
       </div>
       <div class="tab-content">
            <div class="tab-pane active" id="data" role="tabpanel" aria-labelledby="data-tab">
                <div>
                    <div class="row row-spacing mb-2">
                        <div class="col-md-6">
                            <button class="btn btn-info" @click="goToCapture()">
                                Configuration
                            </button>
                            <label class="text-warning">&nbsp; Prices are for HALO Quotation.</label>
                        </div>
                        <div class="col-md-6">
                            <div class="form-inline float-right">
                                <label class="mr-2 my-0">$ 1.00 = R</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control form-control-sm mr-2"
                                    v-model.number="microsoftROE"
                                />
                                <button class="btn btn-sm btn-primary" @click="updateExchangeRate()">Update</button>
                            </div>
                        </div>
                    </div>
                    <div class="row row-spacing mb-2">
                        <div class="col-md-12">
                            <div class="table-responsive table-bordered" v-if="quotationPackages.length > 0">
                                <table class="table">
                                    <thead>
                                        <tr class="text-nowrap">
                                            <th class="offer-col">Description</th>
                                            <th>Term Duration</th>
                                            <th>Billing Plan</th>
                                            <th>$ 1.00</th>
                                            <th>Cost (excl. VAT)</th>
                                            <th>RRP (excl. VAT)</th>
                                            <th>Last Update</th>
                                        </tr>
                                    </thead>
                                    <tbody 
                                        v-for="(quotationPackage, index) in quotationPackages"
                                         :key="quotationPackage.externalId + index" :class="getRowClass(quotationPackage, index)"
                                    >
                                        <tr>
                                            <td class="offer-col">{{ quotationPackage.label }}</td>
                                            <td class="text-center">
                                                <span :class="getQuotationColorTerm(quotationPackage.contractTerm)">{{ quotationPackage.contractTerm }}</span>
                                            </td>
                                            <td class="text-center">
                                                <span :class="getQuotationColorBilling(quotationPackage.billingFrequency)">{{ quotationPackage.billingFrequency }}</span>
                                            </td>
                                            <td>{{ currencyFormat(quotationPackage.exchangeRate) }}</td>
                                            <td class="text-nowrap">{{ currencyFormat(quotationPackage.costInRand) }}</td>
                                            <td class="text-nowrap">{{ currencyFormat(quotationPackage.priceInRands) }}</td>
                                            <td class="text-nowrap text-center">{{ lastUpdateFormat(quotationPackage.modified) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="alert alert-info">No Microsoft Quotation Packages Available</div>
                        </div>
                    </div>
                </div>
            </div>
       </div>       
    </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import QuotationPricing from "@/components/Admin/QuotationPricing";
import { getProduct, saveProduct } from "@/api/v1/products.api";

export default {
    extends: PriceFunctions,
    components: {
        QuotationPricing,
    },
    data() {
        return {
            microsoftProduct: {},
            microsoftROE: 0.00,

            quotationPackages: []
        }
    },
    props: {
        productNumber: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        this.refreshPackages();
    },
    methods: {
        refreshPackages() {
            this.getPublishedPackages();
            this.getExchangeRate();
        },
        getPublishedPackages() {
            this.$http.get(this.$config.aimsAPIv3 + "quotation/microsoft/published")
            .then(response => {
                this.quotationPackages = response.data;
            }, error => {
                console.error(error);
                this.showError("Error fetching Microsoft Quotations", error);
            });
        },
        getExchangeRate() {
            getProduct(this.productNumber).then((success) => {
                this.microsoftProduct = success.data;
                this.microsoftROE = this.microsoftProduct.productvariables.find(v => v.name === "microsoft-exchange-rate").value;
            });  
        },
        updateExchangeRate() {
            this.$swal({
                title: "Update Exchange Rate and Publish all prices.",
                text: "HALO API has a rate limit. Please wait a few moments after Update.",
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {

                    const productCopy = this.deepCopyObject(this.microsoftProduct);        
                    const productObj = {
                        product: productCopy,
                        productVariables: productCopy.productvariables,
                    };
                    
                    saveProduct(productObj).then((response) => {
                        this.showSuccess(response.data.message);
                        this.$http.post(this.$config.aimsAPIv3 + "quotation/microsoft/update/" + this.productNumber + "/roe", this.microsoftROE)
                        .then(response => {
                            this.showSuccess(response.data.message);
                            this.refreshPackages();
                        }, error => {
                            console.error(error);
                            this.showError("Error Updating Packages", error);
                        })
                    }).catch((error) => {
                        console.error(error);
                        this.showError("Error updating exchange rate", error);
                    });

                }
            });
        },
        getQuotationColorTerm(attribute) {
            if (attribute == "Month to month") {
                return "badge badge-m"
            } else 
            if (attribute == "1 Year") {
                return "badge badge-1y"
            } else 
            if (attribute == "3 Year") {
                return "badge badge-3y"
            } else {
                return "badge badge-info"
            }
        },
        getQuotationColorBilling(attribute) {
            if (attribute == "Monthly") {
                return "badge badge-m"
            } else 
            if (attribute == "Yearly") {
                return "badge badge-1y"
            } else 
            if (attribute == "Triennial") {
                return "badge badge-3y"
            } else {
                return "badge badge-info"
            }
        },
        lastUpdateFormat(date) {
            if (!date) return "";

            const d = new Date(date.replace(" ", "T"));
            
            if (isNaN(d.getTime())) return date;

            const optionsDate = { month: "short", day: "numeric" };
            const datePart = d.toLocaleDateString("en-US", optionsDate);
            const timePart = d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            return `${datePart} (${timePart})`;
        },
        getRowClass(q, index) {
            if (index === 0) {
                return 'row-light';
            }

            const prev = this.quotationPackages[index - 1];

            if (q.externalId === prev.externalId) {
                return this.getRowClass(prev, index - 1);
            }

            const prevClass = this.getRowClass(prev, index - 1);
            return prevClass === 'row-light' ? "row-dark" : "row-light";
        },
        goToCapture() {
            const { href } = this.$router.resolve("/main/microsoftquotation");
            window.open(href, '_blank'); 
        }
    }
}
</script>

<style scoped>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f05050 !important;
}
.nav-pills .nav-link {
  background-color: #f3f2ee;
}
a {
  color: rgba(0, 0, 0, 0.6);
}

.badge-m {
  background-color: #ee0909 !important;
  color: #fff;
}

.badge-1y {
  background-color: #0088ff !important;
  color: #fff;
}

.badge-3y {
  background-color: #20ae52 !important;
  color: #fff;
}

.row-light {
  background-color: #f0f0f0;
}

.row-dark {
  background-color: #f9f9f9;
}

th.offer-col,
td.offer-col {
  width: 350px;
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>